export const MEDIA_IS_READY = 4;



// WEBPACK FOOTER //
// ./src/config.js